export const captacaoSemestralOptions = {
	series: [
		{
			name: 'Ajustado',
			type: 'column',
			data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
		},
		{
			name: 'Total',
			type: 'column',
			data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
		},
		{
			name: 'Meta',
			type: 'line',
			data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
		},
	],
	chart: {
		animations: {
			enabled: false,
		},
		fontFamily: 'Roboto Flex, sans-serif',
		height: 350,
		width: '100%',
		type: 'line',
		toolbar: {
			show: false,
		},
	},
	noData: {
		text: 'Sem Dados',
		align: 'center',
		verticalAlign: 'middle',
		offsetX: 0,
		offsetY: 0,
		style: {
			color: undefined,
			fontSize: '14px',
			fontFamily: undefined,
		},
	},
	subtitle: {
		text: 'CAPTAÇÃO DO SEMESTRAL VS META',
		offsetY: 5,
		style: {
			fontSize: '12px',
			fontWeight: '600',
			fontFamily: undefined,
			color: '#949799',
		},
	},
	responsive: [
		{
			breakpoint: 480,
			options: {
				legend: {
					position: 'bottom',
					offsetX: -10,
					offsetY: 0,
				},
			},
		},
	],

	plotOptions: {
		//bar
		bar: {
			borderRadius: 6,
			colors: {},
		},
		//line
		line: {
			dataLabels: {
				enabled: false,
			},
		},
	},
	fill: {
		opacity: 1,
	},

	grid: {
		borderColor: '#E9ECEF',
		strokeDashArray: 0,
		position: 'back',

		xaxis: {
			lines: {
				show: true,
			},
		},
		yaxis: {
			lines: {
				show: true,
			},
		},
	},
	stroke: {
		width: [0, 0, 2],
		curve: 'straight',
		// curve: ['smooth', 'straight', 'stepline']
	},

	dataLabels: {
		enabled: false,
		offsetY: -12,
		style: {
			fontSize: '10px',
			colors: ['#E91E63'],
		},
		background: {
			enabled: false,
		},
		formatter: function (val, opts) {
			if (opts.seriesIndex === 1) {
				return 'R$ ' + GLOBAL.FMoneyK(val)
			} else {
				return ''
			}
		},
	},
	labels: [
		'01/05',
		'02/05',
		'03/05',
		'04/05',
		'05/05',
		'06/05',
		'07/05',
		'08/05',
		'09/05',
		'10/05',
		'11/05',
		'12/05',
	],
	xaxis: {
		// type: "datetime",
		labels: {
			// format: "dd/MM",
			rotate: 0,
			//rotateAlways: true,
			style: {
				fontSize: '10px',
				fontWeight: 500,
			},
		},
		crosshairs: {
			show: false,
		},
		tooltip: {
			enabled: true,
		},
	},
	yaxis: {
		forceNiceScale: true,

		labels: {
			formatter: (value, i) => {
				return GLOBAL.FormatREAL(String(value))
			},

			style: {
				fontSize: '10px',
				fontWeight: 500,
			},
		},
	},

	legend: {
		show: true,
		position: 'top',
		horizontalAlign: 'right',
		offsetY: -25,
		onItemClick: {
			toggleDataSeries: true,
		},
		onItemHover: {
			highlightDataSeries: true,
		},
	},

	colors: ['#6D6F71', '#003769', '#C11F39'],
}

const barOptions2 = {
	series: [
		{
			name: 'Previsto',
			data: [44, 55, 41, 67, 22, 43],
		},
		{
			name: 'Realizado',
			data: [13, 23, 20, 8, 13, 27],
		},
	],
	chart: {
		type: 'bar',
		height: 350,
		stacked: true,
		toolbar: {
			show: false,
		},
		zoom: {
			enabled: true,
		},
	},
	responsive: [
		{
			breakpoint: 480,
			options: {
				legend: {
					position: 'bottom',
					offsetX: -10,
					offsetY: 0,
				},
			},
		},
	],
	plotOptions: {
		bar: {
			horizontal: false,
			borderRadius: 6,
			borderRadiusApplication: 'end',
			borderRadiusWhenStacked: 'last',
			dataLabels: {
				total: {
					enabled: false,
				},
			},
		},
	},
	colors: ['#6D6F71', '#003769'],
	xaxis: {
		type: 'text',
		categories: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun'],
	},
	subtitle: {
		text: 'CAPTAÇÃO DO SEMESTRAL VS META',
		offsetY: 5,
		style: {
			fontSize: '12px',
			fontWeight: '600',
			fontFamily: undefined,
			color: '#949799',
		},
	},
	legend: {
		position: 'top',
		horizontalAlign: 'right',
		offsetY: -25,
	},
	fill: {
		opacity: 1,
	},
	grid: {
		show: true,
		xaxis: {
			lines: {
				show: true,
			},
		},
		yaxis: {
			lines: {
				show: true,
			},
		},
	},
}
